import { WalletSlice } from '../types/wallet-slice.type';
import { useWalletStore } from './useWalletStore';

export function useZkLoginWallet(): WalletSlice {
	return useWalletStore((state) => state.zkLoginWallet);
}
